import React, { useEffect, useState, useMemo } from 'react';
import AdTable from './AdsTable.js';
import { useTableState } from '../utils/useTableState.js';
import { columnsConfig } from '../MyAds/tableConfig.js';
import Select from 'react-select';
import Datepicker from 'react-tailwindcss-datepicker';
 const types = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "full_page",
    label: "Full Image",
  },
  {
    value: "full_video",
    label: "Full Video",
  },
  {
    value: "promoted_image_story",
    label: "Promoted Image Story ",
  },
    {
        value:"promoted_video_story",
        label:"Promoted Video Story"
    },
    {
        value:"half_video",
        label:"Half Video"
    },
    {
    value: "classifiedads",
    label: "Classified Ads"
  }
]
// Status options from cellRenderers.js
const STATUS_OPTIONS = [
    { value: 2, label: 'Saved' },
    { value: 3, label: 'Picked' },
    { value: 4, label: 'Completed' },
    { value: 5, label: 'Rejected' },
    { value: 6, label: 'Accepted' },
];

const PendingAds = ({ isActive }) => {
    const {
        fetchPendingAds,
        currentPage,
        adsData,
        designers,
        fetchDesigners,
        loading,
        totalPages,
        showActionsMenu,
        modal,
        drawer,
        expandedVersionsRow,
        fetchContentWriters,
        actionHandlers,
        renderCell,
        getModalAlt,
        closeExpandedRows,
        handleDesignerChange,
        handleContentWriterChange,
        contentWriters,
        handlePageClick,
        fetchContent
    } = useTableState();
    // Filter state
    const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });
    const [designer, setDesigner] = useState(null);
    const [status, setStatus] = useState(null);
    const [adType, setAdType] = useState(null);
    const [search, setSearch] = useState('');

    // Designer options for react-select
    const designerOptions = useMemo(() =>
        designers.map(d => ({ value: d.designer_id, label: d.name })),
        [designers]
    );


    // Fetch designers on mount
    useEffect(() => {
        fetchDesigners();
        fetchContentWriters();
    }, []);

    // Fetch ads on filter or page change
    useEffect(() => {
        fetchPendingAds(currentPage, isActive, {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            designerId: designer ? designer.value : null,
            status: status ? status.value : null,
            adType: adType && adType.value !== 'all' ? adType.value : null,
            search: search || null,
        });
    }, [isActive, currentPage, dateRange, designer, status, adType, search]);

    // Handlers
    const handleDateChange = (val) => setDateRange(val);
    const handleDesignerChangeSelect = (val) => setDesigner(val);
    const handleStatusChange = (val) => setStatus(val);
    const handleAdTypeChange = (val) => setAdType(val);
    const handleSearchChange = (e) => setSearch(e.target.value);

    return (
        <div>
            {/* Filter Bar */}
            <div className="flex flex-wrap gap-4 mb-4 items-end">
                <div className="w-64">
                    <label className="block text-xs font-semibold mb-1">Start Date Range</label>
                    <div className='border rounded-lg  border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-66'>
                        <Datepicker
                            value={dateRange}
                            onChange={handleDateChange}
                            primaryColor="cyan"
                            showShortcuts={true}
                            classNames="form-input"
                            asSingle={false}
                        />
                    </div>
                </div>
                <div className="w-64">
                    <label className="block text-xs font-semibold mb-1">Search</label>
                    <input
                        type="text"
                        className="w-full border rounded px-2 py-1"
                        placeholder="Search by campaign/brand/client"
                        value={search}
                        onChange={handleSearchChange}
                    />
                </div>
                <div className="w-64">
                    <label className="block text-xs font-semibold mb-1">Ad Type</label>
                    <Select
                        options={types}
                        value={adType}
                        onChange={handleAdTypeChange}
                        isClearable
                        placeholder="Select Ad Type"
                        classNamePrefix="react-select"
                    />
                </div>
                <div className="w-64">
                    <label className="block text-xs font-semibold mb-1">Designer</label>
                    <Select
                        options={designerOptions}
                        value={designer}
                        onChange={handleDesignerChangeSelect}
                        isClearable
                        placeholder="Select Designer"
                        classNamePrefix="react-select"
                    />
                </div>
                <div className="w-64">
                    <label className="block text-xs font-semibold mb-1">Design Status</label>
                    <Select
                        options={STATUS_OPTIONS}
                        value={status}
                        onChange={handleStatusChange}
                        isClearable
                        placeholder="Select Status"
                        classNamePrefix="react-select"
                    />
                </div>
            </div>
            <div className='flex items-center justify-center'>
                <AdTable
                    data={adsData}
                    columns={columnsConfig.pending_ads}
                    loading={loading}
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onPageClick={handlePageClick}
                    isPending={true}
                    designers={designers}
                    contentWriters={contentWriters}
                    showActionsMenu={showActionsMenu}
                    modal={modal}
                    drawer={drawer}
                    expandedVersionsRow={expandedVersionsRow}
                    actionHandlers={actionHandlers}
                    renderCell={renderCell}
                    getModalAlt={getModalAlt}
                    closeExpandedRows={closeExpandedRows}
                    handleDesignerChange={handleDesignerChange}
                    handleContentWriterChange={handleContentWriterChange}
                    fetchContent={fetchContent}
                />
            </div>
        </div>
    );
};

export default PendingAds; 